'use strict';

/* Directives */

var cacheCleanerDirectives = angular.module('cacheCleanerDirectives', []);


// WEBPACK FOOTER //
// ./scripts/directives.js